import '@babel/polyfill'
import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

export const globalStore = new Vue({
  data: {
    locations: null,
    inventoryLevels: null
  }
})

require('./assets/css/style.css')

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
